module.exports = __webpack_public_path__ + "media/images/athletes/1629-fd78af98c009b7761a47fd7a50e31684.png";